if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class BrandedMediaGallery extends HTMLElement {
    connectedCallback() {
      if (this.swiper || typeof Swiper === 'undefined') return;
      const viewer = this.querySelector('.mySwiper');
      if (!viewer) return;
      this.thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
      this.liveRegion = this.querySelector('[id^="GalleryStatus"]');
      const slides = Array.from(viewer.querySelectorAll('.swiper-slide'));
      const initialSlide = Math.max(0, slides.findIndex((slide) => slide.dataset.mediaId === this.dataset.initialMedia));
      this.swiper = new Swiper(viewer, {
        slidesPerView: 1,
        spaceBetween: 10,
        rewind: true,
        initialSlide,
        pagination: { el: viewer.querySelector('.swiper-pagination'), type: 'bullets' },
        navigation: {
          nextEl: viewer.querySelector('.swiper-button-next'),
          prevEl: viewer.querySelector('.swiper-button-prev')
        },
        on: { slideChange: (swiper) => this.updateActiveMedia(swiper, true) }
      });
      this.thumbnailClick = (event) => {
        const thumbnail = event.target.closest('[data-target]');
        if (thumbnail && this.thumbnails.contains(thumbnail)) this.setActiveMedia(thumbnail.dataset.target);
      };
      this.thumbnails?.addEventListener('click', this.thumbnailClick);
      this.updateActiveMedia(this.swiper, false);
    }

    disconnectedCallback() {
      this.thumbnails?.removeEventListener('click', this.thumbnailClick);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    setActiveMedia(mediaId) {
      if (!this.swiper) return;
      this.swiper.update();
      const index = Array.from(this.swiper.slides).findIndex((slide) => slide.dataset.mediaId === mediaId);
      if (index < 0) return;
      this.swiper.slideTo(index);
      this.updateActiveMedia(this.swiper, false);
    }

    updateActiveMedia(swiper, announce) {
      const active = swiper.slides[swiper.activeIndex];
      if (!active) return;
      Array.from(swiper.slides).forEach((slide) => slide.classList.toggle('is-active', slide === active));
      this.thumbnails?.querySelectorAll('[data-target]').forEach((thumbnail) => {
        const button = thumbnail.querySelector('button');
        if (!button) return;
        if (thumbnail.dataset.target === active.dataset.mediaId) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
      if (announce) {
        window.pauseAllMedia?.();
        active.querySelector('deferred-media')?.loadContent(false);
        if (this.liveRegion && window.accessibilityStrings?.imageAvailable) {
          this.liveRegion.setAttribute('aria-hidden', 'false');
          this.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace('[index]', swiper.activeIndex + 1);
        }
      }
    }
  });
}
